import React from 'react'
import DraggableTool from './DraggableTool'

const Toolbox = () => {
  return (
    <div className="flex flex-col flex-1 w-full max-w-xs min-w-[20rem]">
      <DraggableTool type="text">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="8" width="18" height="2" fill="currentColor" />
          </svg>
          Text Input
        </div>
      </DraggableTool>

      <DraggableTool type="text-area">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="4" width="18" height="2" fill="currentColor" />
            <rect x="3" y="10" width="18" height="2" fill="currentColor" />
            <rect x="3" y="16" width="18" height="2" fill="currentColor" />
          </svg>
          Text Area
        </div>
      </DraggableTool>

      <DraggableTool type="number">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          🔢 Number Input
        </div>
      </DraggableTool>

      <DraggableTool type="email">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          📧 Email Input
        </div>
      </DraggableTool>

      <DraggableTool type="date">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          📅 Date Input
        </div>
      </DraggableTool>

      <DraggableTool type="dropdown">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polygon points="6,9 12,15 18,9" fill="currentColor" />
          </svg>
          Dropdown
        </div>
      </DraggableTool>

      <DraggableTool type="checkbox">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          ✅ Checkbox
        </div>
      </DraggableTool>

      <DraggableTool type="radio">
        <div className="cursor-pointer m-1.5 p-1.5 border-2 border-dashed border-slate-300 flex items-center">
          🔘 Radio
        </div>
      </DraggableTool>
    </div>
  )
}

export default Toolbox
